"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * TimedReveal is a component to show a component after a delay.
 * On SSR or pre-rendering, it returns null. The timer kicks in when
 * the component mounts on the client.
 *
 * Use like <TimedReveal delay={2000}>Text hidden for 2 seconds</div>
 *
 * @param {Object} props
 * @param {Node} props.children React children. This is what's hidden by TimedReveal
 * @param {Number} props.delay Delay is in milliseconds. Will show children after this time.
 * @param {Function} props.timeDoneCb Callback to tell when the timer is over
 */
var TimedReveal = /*#__PURE__*/function (_React$Component) {
  _inherits(TimedReveal, _React$Component);

  var _super = _createSuper(TimedReveal);

  function TimedReveal(props) {
    var _this;

    _classCallCheck(this, TimedReveal);

    _this = _super.call(this, props);
    _this.state = {
      timerDone: false
    };
    return _this;
  }

  _createClass(TimedReveal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          delay = _this$props.delay,
          timerDoneCb = _this$props.timerDoneCb;
      this.timeout = setTimeout(function () {
        timerDoneCb();

        _this2.setState({
          timerDone: true
        });
      }, delay);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var timerDone = this.state.timerDone;
      var children = this.props.children;

      if (!timerDone) {
        return null;
      }

      return children;
    }
  }]);

  return TimedReveal;
}(_react["default"].Component);

TimedReveal.propTypes = {
  children: _propTypes["default"].node.isRequired,
  delay: _propTypes["default"].number,
  timerDoneCb: _propTypes["default"].func
};
TimedReveal.defaultProps = {
  delay: 0,
  timerDoneCb: function timerDoneCb() {}
};
var _default = TimedReveal;
exports["default"] = _default;